import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';

const useUpdateMovementOperation = () => {
  const { enqueueSnackbar } = useSnackbar();

  const updateRequest = (
    payload,
    getMovementOperationList,
    setIsEditModalOpen,
    setEditLoading,
  ) => {
    axiosClient
      .put(`Operation/Movement/Update`, {
        guid: payload.guid,
        title: payload.title,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          getMovementOperationList?.();
          setIsEditModalOpen?.(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setEditLoading?.(false));
  };

  return { updateRequest };
};

export default useUpdateMovementOperation;
